<template>
  <div id="tab-mbl2">
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-dropdown
            no="1"
            :class="readonly?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1);}"
          >
            {{ command1 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.CodeSearching')">{{ $t('SeaExport.CodeSearching') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromTheLastTime')">{{ $t('SeaExport.CopyFromTheLastTime') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromOtherBill')">{{ $t('SeaExport.CopyFromOtherBill') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown
            no="2"
            style="padding-left: 5px;"
            :class="btnBLConfirmDisabled?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command2)"
            @command="p=>{command2=p;commandHandle(command2)}"
          >
            {{ command2 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.InviteToChecktheBL')">{{
                $t('SeaExport.InviteToChecktheBL')
              }}
              </el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_M/HBL_identification'])" :command="$t('SeaExport.IdentificationList')">{{ $t('SeaExport.IdentificationList') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CheckingHistory')">{{
                $t('SeaExport.CheckingHistory')
              }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-checkbox
            v-model="form.edi"
            no="3"
            :disabled="readonly"
            style="margin-left: 10px;"
          >EDI</el-checkbox>
          <el-checkbox v-model="form.oversea" no="4" style="margin-left: -20px;" :disabled="readonly">{{ $t('SeaExport.BlBeReleased') }}</el-checkbox>
          <el-checkbox
            v-model="form.printParam1"
            no="5"
            style="margin-left: -20px"
            :disabled="readonly"
            @change="pm.chargeEsaeq()"
          >Part of</el-checkbox>
          <el-checkbox
            v-model="form.printParam3"
            no="6"
            style="margin-left: -20px"
            :disabled="readonly"
            @change="pm.changeContainer()"
          >{{ $t('SeaExport.ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS') }}</el-checkbox>
        </div>
      </div>
    </div>
    <div style="width: fit-content">
      <!--      <div :style="{'display':'flex','min-width':job.typeMBL===BillType.MERGE_BILL_TYPE.code?'1591px':'1560px'}">-->
      <div style="display: flex">
        <div class="section form-column">
          <el-form v-show="!form.showDetail" label-width="70px" label-position="right" style="height:100%">
            <div style="display: flex; align-items: center; white-space: nowrap; min-width: 100%; margin-bottom: 10px;">
              <span class="title" style="flex-shrink: 0;">{{ $t('SeaExport.ConsigneeShipperAndNotifyInfo') }}</span>
              <div style="flex-grow: 1;" />
              <el-button no="DetailFormat" :disabled="readonly" type="primary" style="flex-shrink: 0;" @click="formatChange(true)">{{ $t('CargoMsg.Cargo_DetailFormat') }} </el-button>
            </div>
            <el-form-item :label="$t('SeaExport.Shipper')" class="auto-width" :class="variableCss.shipperCode">
              <span slot="label" :class="variableCss.shipperLine">{{ $t('SeaExport.Shipper') }}</span>
              <div style="display: flex;width: 100%">
                <el-input
                  v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  ref="shipperCode"
                  v-model="form.shipperCode"
                  :disabled="readonly"
                  no="7"
                  style="flex:1"
                />
                <cargo-advance-select
                  v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  :disabled="readonly"
                  no="8"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{ shipper: true, active: true }"
                  filterable
                  :default-value="form.shipperId||''"
                  style="flex:1"
                  @parentCallBack="p=>{pm.shipperAutoCompleteChange(p)}"
                />
                <el-button no="9" type="primary" :disabled="readonly" style="margin-left: 5px" @click="pm.onClear(1)">{{ $t('SeaExport.Reset') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item
              v-for="count in 7"
              :key="'shipperLine'+count"
              :class="'auto-width ' + getClass('shipperLine',count)"
            >
              <special-character-tip :texts="specialCharCheck['shipperLine'+count]">
                <cargo-input
                  :ref="'shipperLine'+count"
                  v-model="form['shipperLine'+count]"
                  :disabled="readonly"
                  :no="'shipperLine'+count"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showShipperDialog"
                  @change="()=>wrapAddr(form,'shipperLine'+count,count+1 > 6 ? null :'shipperLine'+(count+1),maxChars)"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Consignee')" class="auto-width" :class="variableCss.consigneeCode">
              <span slot="label" :class="variableCss.consigneeLine">{{ $t('SeaExport.Consignee') }}</span>
              <div style="display: flex">
                <el-input
                  v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  ref="consigneeCode"
                  v-model="form.consigneeCode"
                  :disabled="readonly"
                  no="10"
                  style="flex:1"
                />
                <cargo-advance-select
                  v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  :disabled="readonly"
                  no="11"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{ consignee: true, active: true }"
                  filterable
                  :default-value="form.consigneeId||''"
                  style="flex:1"
                  @parentCallBack="p=>{pm.consigneeAutoCompleteChange(p)}"
                />
                <el-button no="12" type="primary" :disabled="readonly" style="margin-left: 5px" @click="pm.onClear(2)">{{ $t('SeaExport.Reset') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item
              v-for="count in 7"
              :key="'consigneeLine'+count"
              :class="'auto-width ' + getClass('consigneeLine',count)"
            >
              <special-character-tip :texts="specialCharCheck['consigneeLine'+count]">
                <cargo-input
                  :ref="'consigneeLine'+count"
                  v-model="form['consigneeLine'+count]"
                  :disabled="readonly"
                  :no="'consigneeLine'+count"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showConsigneeDialog"
                  @change="()=>wrapAddr(form,'consigneeLine'+count,count+1 > 6 ? null :'consigneeLine'+(count+1),maxChars)"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.NotifyParty')" class="auto-width" :class="variableCss.notifyCode">
              <span slot="label" :class="variableCss.notifyLine">{{ $t('SeaExport.NotifyParty') }}</span>
              <div>
                <el-input
                  v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  ref="notifyCode"
                  v-model="form.notifyCode"
                  :disabled="readonly"
                  no="13"
                  style="flex:1"
                />
                <cargo-advance-select
                  v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  :disabled="readonly"
                  no="14"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{ notify: true, active: true }"
                  filterable
                  :default-value="form.notifyId||''"
                  style="flex:1"
                  @parentCallBack="p=>{pm.notifyAutoCompleteChange(p)}"
                />
                <div style="margin-top: 5px">
                  <el-button no="15" type="primary" :disabled="readonly" @click="pm.onClear(3)">{{ $t('SeaExport.Reset') }}</el-button>
                  <el-button no="16" type="primary" :disabled="readonly" style="margin-left: 5px" @click="pm.onCopyConsignee()">{{ $t('SeaExport.CopyTheConsignee') }}</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item
              v-for="count in 7"
              :key="'notifyLine'+count"
              :class="'auto-width ' + getClass('notifyLine',count)"
            >
              <special-character-tip :texts="specialCharCheck['notifyLine'+count]">
                <cargo-input
                  :ref="'notifyLine'+count"
                  v-model="form['notifyLine'+count]"
                  :disabled="readonly"
                  :no="'notifyLine'+count"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showNotifyDialog"
                  @change="()=>wrapAddr(form,'notifyLine'+count,count+1 > 6 ? null :'notifyLine'+(count+1),maxChars)"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item label-width="0" class=" auto-width">
              <span style="color:#404144">ALSO NOTIFY</span>
            </el-form-item>
            <el-form-item class=" auto-width">
              <cargo-rich-textarea
                v-model="form.alsoNotify"
                no="17"
                :disabled="readonly"
                wrap-symbol="r"
                :text-chars="0"
                auto-half-word
                auto-uppercase
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{form.alsoNotify=val},notUppercaseShipperConsigneNotify, {
                  warningCount: 45,
                  maxChar: 0,autoUppercase:true,autoHalfWord:true
                })"
              />
            </el-form-item>
            <el-form-item
              v-if="job.paymentTermMBL === '3P'"
              class="auto-width"
              style="padding-top: 5px"
            >
              <span slot="label">{{ $t('CargoMsg.Cargo_Payment1') }}</span>
              <div style="display: flex;width: 100%">
                <el-input
                  v-model="form.paymentCode"
                  :disabled="readonly"
                  no="paymentCode"
                  style="flex:1"
                />
                <el-button
                  no="BringInDat"
                  type="primary"
                  style="margin-left: 5px"
                  :disabled="readonly "
                  @click="pm.paymentImportData(true)"
                >{{ $t('CargoMsg.Cargo_BringInData') }}
                </el-button>
              </div>
            </el-form-item>
            <el-form-item
              v-for="count in 7"
              v-if="job.paymentTermMBL === '3P'"
              :key="'paymentLine'+count"
              class="auto-width"
            >
              <cargo-input
                :ref="'paymentLine'+count"
                v-model="form['paymentLine'+count]"
                :disabled="readonly"
                :no="'paymentLine'+count"
                :auto-uppercase="isUppercase"
                :filter-chars="false"
                :use-read-only="true"
                @dblclick.native="showPaymentDialog"
                @change="()=>wrapAddr(form,'paymentLine'+count,count+1 > 6 ? null :'paymentLine'+(count+1),0)"
              />
            </el-form-item>
          </el-form>
          <el-form
            v-show="form.showDetail"
            label-width="70px"
            label-position="right"
            style="height:100%"
          >
            <!--  发货人 -->
            <div style="display: flex; align-items: center; white-space: nowrap; min-width: 100%; margin-bottom: 10px;">
              <span class="title" style="flex-shrink: 0;">{{ $t('SeaExport.ConsigneeShipperAndNotifyInfo') }}</span>
              <div style="flex-grow: 1;" />
              <el-button no="GeneralFormat" :disabled="readonly" type="primary" style="flex-shrink: 0;" @click="formatChange(false)">{{ $t('CargoMsg.Cargo_GeneralFormat') }} </el-button>
            </div>
            <el-form-item
              class="auto-width"
              :class="variableCss.shipperCode"
            >
              <span slot="label" :class="variableCss.shipperLine">{{ $t('SeaExport.Shipper') }}</span>
              <div style="display: flex;width: 100%">
                <el-input
                  v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  ref="shipperCode"
                  v-model="form.shipperCode"
                  :disabled="readonly"
                  no="7"
                  style="flex:1"
                />
                <cargo-advance-select
                  v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  :disabled="readonly"
                  no="8"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{ shipper: true, active: true }"
                  filterable
                  :default-value="form.shipperId||''"
                  style="flex:1"
                  @parentCallBack="p=>{pm.shipperAutoCompleteChange(p, true)}"
                />
                <el-button no="9" type="primary" :disabled="readonly" style="margin-left: 5px" @click="pm.onClear(1, true)">{{ $t('SeaExport.Reset') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Name')"
              class="auto-width"
            >
              <cargo-input
                v-model="form.shipperLine1"
                no="shipperLine1"
                :disabled="readonly"
                :filter-chars="false"
                :use-read-only="true"
                @dblclick.native="showShipperDialog"
                @change="()=>wrapAddr(form,'shipperLine1','shipperLine2',maxChars)"
              />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.Addr') + '1'"
              class="auto-width"
            >
              <cargo-input
                v-model="form.shipperLine2"
                no="shipperLine2"
                :disabled="readonly"
                :filter-chars="false"
                :use-read-only="true"
                @dblclick.native="showShipperDialog"
                @change="()=>wrapAddr(form,'shipperLine2','shipperLine3',maxChars)"
              />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.Addr') + '2'"
              class="auto-width"
            >
              <cargo-input
                v-model="form.shipperLine3"
                no="shipperLine3"
                :disabled="readonly"
                :filter-chars="false"
                :use-read-only="true"
                @dblclick.native="showShipperDialog"
                @change="()=>wrapAddr(form,'shipperLine3','shipperLine4',maxChars)"
              />
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Country')"
              style="margin-bottom: -10px"
            >
              <div style="display:flex;">
                <el-input
                  v-model="form.shipperCountry"
                  no="shipperCountry"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="$t('CargoMsg.Cargo_CityP')"
                  class="auto-width"
                >
                  <el-input
                    v-model="form.shipperCity"
                    no="shipperCity"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Province1')"
            >
              <div style="display:flex;">
                <el-input
                  v-model="form.shipperProvince"
                  no="shipperProvince"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="$t('CargoMsg.Cargo_PostalCode')"
                  class="auto-width"
                >
                  <el-input
                    v-model="form.shipperZipCode"
                    no="shipperZipCode"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Tel')"
            >
              <div style="display:flex;">
                <el-input
                  v-model="form.shipperMobile"
                  no="shipperMobile"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="$t('CargoMsg.Cargo_email')"
                  class="auto-width"
                >
                  <el-input
                    v-model="form.shipperEmail"
                    no="shipperEmail"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Contact')"
              class="auto-width"
            >
              <div style="display:flex;padding-bottom: 5px">
                <el-input
                  v-model="form.shipperContact"
                  no="shipperContact"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="'Fax'"
                >
                  <el-input
                    v-model="form.shipperFax"
                    no="shipperFax"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>

            <!-- 收货人 -->
            <el-form-item
              class="auto-width"
              :class="variableCss.consigneeCode"
            >
              <span slot="label" :class="variableCss.consigneeLine">{{ $t('SeaExport.Consignee') }}</span>
              <div style="display: flex">
                <el-input
                  v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  ref="consigneeCode"
                  v-model="form.consigneeCode"
                  :disabled="readonly"
                  no="10"
                  style="flex:1"
                />
                <cargo-advance-select
                  v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  :disabled="readonly"
                  no="11"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{ consignee: true, active: true }"
                  filterable
                  :default-value="form.consigneeId||''"
                  style="flex:1"
                  @parentCallBack="p=>{pm.consigneeAutoCompleteChange(p, true)}"
                />
                <el-button no="12" type="primary" :disabled="readonly" style="margin-left: 5px" @click="pm.onClear(2, true)">{{ $t('SeaExport.Reset') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Name')"
              class="auto-width"
            >
              <cargo-input
                v-model="form.consigneeLine1"
                no="consigneeLine1"
                :disabled="readonly"
                :filter-chars="false"
                :use-read-only="true"
                @dblclick.native="showConsigneeDialog"
                @change="()=>wrapAddr(form,'consigneeLine1','consigneeLine2',maxChars)"
              />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.Addr') + '1'"
              class="auto-width"
            >
              <cargo-input
                v-model="form.consigneeLine2"
                no="consigneeLine2"
                :disabled="readonly"
                :filter-chars="false"
                :use-read-only="true"
                @dblclick.native="showConsigneeDialog"
                @change="()=>wrapAddr(form,'consigneeLine2','consigneeLine3',maxChars)"
              />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.Addr') + '2'"
              class="auto-width"
            >
              <cargo-input
                v-model="form.consigneeLine3"
                no="consigneeLine3"
                :disabled="readonly"
                :filter-chars="false"
                :use-read-only="true"
                @dblclick.native="showConsigneeDialog"
                @change="()=>wrapAddr(form,'consigneeLine3','consigneeLine4',maxChars)"
              />
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Country')"
              class="auto-width"
            >
              <div style="display:flex;">
                <el-input
                  v-model="form.consigneeCountry"
                  no="consigneeCountry"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="$t('CargoMsg.Cargo_CityP')"
                  class="auto-width"
                >
                  <el-input
                    v-model="form.consigneeCity"
                    no="consigneeCity"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Province1')"
              class="auto-width"
            >
              <div style="display:flex;">
                <el-input
                  v-model="form.consigneeProvince"
                  no="consigneeProvince"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="$t('CargoMsg.Cargo_PostalCode')"
                  class="auto-width"
                >
                  <el-input
                    v-model="form.consigneeZipCode"
                    no="consigneeZipCode"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Tel')"
            >
              <div style="display:flex;">
                <el-input
                  v-model="form.consigneeMobile"
                  no="consigneeMobile"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="$t('CargoMsg.Cargo_email')"
                  class="auto-width"
                >
                  <el-input
                    v-model="form.consigneeEmail"
                    no="consigneeEmail"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Contact')"
              class="auto-width"
            >
              <div style="display:flex;padding-bottom: 5px">
                <el-input
                  v-model="form.consigneeContact"
                  no="consigneeContact"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="'Fax'"
                >
                  <el-input
                    v-model="form.consigneeFax"
                    no="consigneeFax"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>
            <!-- 通知人 -->
            <el-form-item
              class="auto-width"
              :class="variableCss.notifyCode"
            >
              <span slot="label" :class="variableCss.notifyLine">{{ $t('SeaExport.NotifyParty') }}</span>
              <div>
                <el-input
                  v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  ref="notifyCode"
                  v-model="form.notifyCode"
                  :disabled="readonly"
                  no="13"
                  style="flex:1"
                />
                <cargo-advance-select
                  v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                  :disabled="readonly"
                  no="14"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{ notify: true, active: true }"
                  filterable
                  :default-value="form.notifyId||''"
                  style="flex:1"
                  @parentCallBack="p=>{pm.notifyAutoCompleteChange(p, true)}"
                />
                <div style="margin-top: 5px">
                  <el-button no="15" type="primary" :disabled="readonly" @click="pm.onClear(3, true)">{{ $t('SeaExport.Reset') }}</el-button>
                  <el-button no="16" type="primary" :disabled="readonly" style="margin-left: 5px" @click="pm.onCopyConsignee(true)">{{ $t('SeaExport.CopyTheConsignee') }}</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Name')"
              class="auto-width"
            >
              <cargo-input
                v-model="form.notifyLine1"
                no="notifyLine1"
                :disabled="readonly"
                :filter-chars="false"
                :use-read-only="true"
                @dblclick.native="showNotifyDialog"
                @change="()=>wrapAddr(form,'notifyLine1','notifyLine2',maxChars)"
              />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.Addr') + '1'"
              class="auto-width"
            >
              <cargo-input
                v-model="form.notifyLine2"
                no="notifyLine2"
                :disabled="readonly"
                :filter-chars="false"
                :use-read-only="true"
                @dblclick.native="showNotifyDialog"
                @change="()=>wrapAddr(form,'notifyLine2','notifyLine3',maxChars)"
              />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.Addr') + '2'"
              class="auto-width"
            >
              <cargo-input
                v-model="form.notifyLine3"
                no="notifyLine3"
                :disabled="readonly"
                :filter-chars="false"
                :use-read-only="true"
                @dblclick.native="showNotifyDialog"
                @change="()=>wrapAddr(form,'notifyLine3','notifyLine4',maxChars)"
              />
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Country')"
              class="auto-width"
            >
              <div style="display:flex;">
                <el-input
                  v-model="form.notifyCountry"
                  no="notifyCountry"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="$t('CargoMsg.Cargo_CityP')"
                  class="auto-width"
                >
                  <el-input
                    v-model="form.notifyCity"
                    no="notifyCity"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Province1')"
              class="auto-width"
            >
              <div style="display:flex;">
                <el-input
                  v-model="form.notifyProvince"
                  no="notifyProvince"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="$t('CargoMsg.Cargo_PostalCode')"
                  class="auto-width"
                >
                  <el-input
                    v-model="form.notifyZipCode"
                    no="notifyZipCode"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Tel')"
            >
              <div style="display:flex;">
                <el-input
                  v-model="form.notifyMobile"
                  no="notifyMobile"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="$t('CargoMsg.Cargo_email')"
                  class="auto-width"
                >
                  <el-input
                    v-model="form.notifyEmail"
                    no="notifyEmail"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Contact')"
              class="auto-width"
            >
              <div style="display:flex;padding-bottom: 5px">
                <el-input
                  v-model="form.notifyContact"
                  no="notifyContact"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="'Fax'"
                >
                  <el-input
                    v-model="form.notifyFax"
                    no="notifyFax"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>
            <!-- ALSO NOTIFY -->
            <el-form-item label-width="100px" class="auto-width" label="ALSO NOTIFY" />
            <el-form-item
              :label="$t('CargoMsg.Cargo_Name')"
              class="auto-width"
            >
              <cargo-input
                v-model="alsoNotify.line1"
                no="alsoNotifyLine1"
                :disabled="readonly"
                :filter-chars="false"
                :use-read-only="true"
                :auto-uppercase="true"
                @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{ summarizeAlso(val) },false,null,true, {
                  warningCount: 45,
                  maxChar: 0,autoUppercase:true,autoHalfWord:true
                })"
                @change="alsoChange"
              />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.Addr') + '1'"
              class="auto-width"
            >
              <cargo-input
                v-model="alsoNotify.line2"
                no="alsoNotifyLine2"
                :disabled="readonly"
                :filter-chars="false"
                :use-read-only="true"
                :auto-uppercase="true"
                @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{ summarizeAlso(val) },false,null,true, {
                  warningCount: 45,
                  maxChar: 0,autoUppercase:true,autoHalfWord:true
                })"
                @change="alsoChange"
              />
            </el-form-item>
            <el-form-item
              :label="$t('SeaExport.Addr') + '2'"
              class="auto-width"
            >
              <cargo-input
                v-model="alsoNotify.line3"
                no="alsoNotifyLine3"
                :disabled="readonly"
                :filter-chars="false"
                :use-read-only="true"
                :auto-uppercase="true"
                @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{ summarizeAlso(val) },false,null,true, {
                  warningCount: 45,
                  maxChar: 0,autoUppercase:true,autoHalfWord:true
                })"
                @change="alsoChange"
              />
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Country')"
              class="auto-width"
            >
              <div style="display:flex;">
                <el-input
                  v-model="form.alsoNotifyCountry"
                  no="alsoNotifyCountry"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="$t('CargoMsg.Cargo_CityP')"
                  class="auto-width"
                >
                  <el-input
                    v-model="form.alsoNotifyCity"
                    no="alsoNotifyCity"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Province1')"
              class="auto-width"
            >
              <div style="display:flex;">
                <el-input
                  v-model="form.alsoNotifyProvince"
                  no="alsoNotifyProvince"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="$t('CargoMsg.Cargo_PostalCode')"
                  class="auto-width"
                >
                  <el-input
                    v-model="form.alsoNotifyZipCode"
                    no="alsoNotifyZipCode"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Tel')"
            >
              <div style="display:flex;">
                <el-input
                  v-model="form.alsoNotifyMobile"
                  no="alsoNotifyMobile"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="$t('CargoMsg.Cargo_email')"
                  class="auto-width"
                >
                  <el-input
                    v-model="form.alsoNotifyEmail"
                    no="alsoNotifyEmail"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_Contact')"
              class="auto-width"
            >
              <div style="display:flex;padding-bottom: 5px">
                <el-input
                  v-model="form.alsoNotifyContact"
                  no="alsoNotifyContact"
                  style="width: 80px"
                  :disabled="readonly"
                />
                <el-form-item
                  :label="'Fax'"
                >
                  <el-input
                    v-model="form.alsoNotifyFax"
                    no="alsoNotifyFax"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                </el-form-item>
              </div>
            </el-form-item>
            <!--          付款方-->
            <div v-if="job.paymentTermMBL === '3P'">
              <el-form-item
                class="auto-width"
              >
                <span slot="label">{{ $t('CargoMsg.Cargo_Payment1') }}</span>
                <div style="display: flex;width: 100%">
                  <el-input
                    v-model="form.paymentCode"
                    no="paymentCode"
                    :disabled="readonly"
                    style="flex:1"
                  />
                  <el-button
                    no="BringInData"
                    type="primary"
                    style="margin-left: 5px"
                    :disabled="readonly"
                    @click="pm.paymentImportData(false)"
                  >{{ $t('CargoMsg.Cargo_BringInData') }}
                  </el-button>
                </div>
              </el-form-item>
              <el-form-item
                :label="$t('CargoMsg.Cargo_Name')"
                class="auto-width"
              >
                <cargo-input
                  v-model="form.paymentLine1"
                  no="paymentLine1"
                  :disabled="readonly"
                  :filter-chars="false"
                  :use-read-only="true"
                  @dblclick.native="showPaymentDialog"
                  @change="()=>wrapAddr(form,'paymentLine1','paymentLine2',0)"
                />
              </el-form-item>
              <el-form-item
                :label="$t('SeaExport.Addr') + '1'"
                class="auto-width"
              >
                <cargo-input
                  v-model="form.paymentLine2"
                  no="paymentLine2"
                  :disabled="readonly"
                  :filter-chars="false"
                  :use-read-only="true"
                  @dblclick.native="showPaymentDialog"
                  @change="()=>wrapAddr(form,'paymentLine2','paymentLine3',0)"
                />
              </el-form-item>
              <el-form-item
                :label="$t('SeaExport.Addr') + '2'"
                class="auto-width"
              >
                <cargo-input
                  v-model="form.paymentLine3"
                  no="paymentLine3"
                  :disabled="readonly"
                  :filter-chars="false"
                  :use-read-only="true"
                  @dblclick.native="showPaymentDialog"
                  @change="()=>wrapAddr(form,'paymentLine3','paymentLine4',0)"
                />
              </el-form-item>
              <el-form-item
                :label="$t('CargoMsg.Cargo_Country')"
                class="auto-width"
              >
                <div style="display:flex;">
                  <el-input
                    v-model="form.paymentCountry"
                    no="paymentCountry"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                  <el-form-item
                    :label="$t('CargoMsg.Cargo_CityP')"
                    class="auto-width"
                  >
                    <el-input
                      v-model="form.paymentCity"
                      no="paymentCity"
                      style="width: 80px"
                      :disabled="readonly"
                    />
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item
                :label="$t('CargoMsg.Cargo_Province1')"
                class="auto-width"
              >
                <div style="display:flex;">
                  <el-input
                    v-model="form.paymentProvince"
                    no="paymentProvince"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                  <el-form-item
                    :label="$t('CargoMsg.Cargo_PostalCode')"
                    class="auto-width"
                  >
                    <el-input
                      v-model="form.paymentPostalCode"
                      no="paymentPostalCode"
                      style="width: 80px"
                      :disabled="readonly"
                    />
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item
                :label="$t('CargoMsg.Cargo_Tel')"
              >
                <div style="display:flex;">
                  <el-input
                    v-model="form.paymentPhone"
                    no="paymentPhone"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                  <el-form-item
                    :label="$t('CargoMsg.Cargo_email')"
                    class="auto-width"
                  >
                    <el-input
                      v-model="form.paymentEmail"
                      no="paymentEmail"
                      style="width: 80px"
                      :disabled="readonly"
                    />
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item
                :label="$t('CargoMsg.Cargo_Contact')"
                class="auto-width"
              >
                <div style="display:flex;padding-bottom: 5px">
                  <el-input
                    v-model="form.paymentContact"
                    no="paymentContact"
                    style="width: 80px"
                    :disabled="readonly"
                  />
                  <el-form-item
                    :label="'Fax'"
                  >
                    <el-input
                      v-model="form.paymentFax"
                      no="paymentFax"
                      style="width: 80px"
                      :disabled="readonly"
                    />
                  </el-form-item>
                </div>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="125px" label-position="right" style="height:100%">
            <span class="title">{{ $t('SeaExport.CargoInfo') }}</span>
            <el-form-item style="display: flex; justify-content: flex-end;">
              <el-button type="primary" @click="syncContainerInfoDialogHandle">{{ $t('SeaExport.SyncContainerInfoTotal') }}</el-button>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.NumberOfPackagesOnBl')" :class="variableCss.quantity">
              <auto-number-input
                v-model="form.quantity"
                no="18"
                :precision="0"
                :min="0"
                :disabled="!isJydEditJobFields"
                @change="pm.quantity_Change(form.quantity)"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Package')" :class="variableCss.packing">
              <!-- <cargo-advance-select
                :select-type="selectTypeNames.basic_data_Packing"
                filterable
                :default-value="form.packing"
                style="width:100%;"
                @parentCallBack="p=>{pm.packing_Change(p)}"
              /> -->
              <cargo-packing-select
                no="19"
                :default-value="form.packing"
                @change="p => {pm.packing_Change(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Pieces2')" :class="variableCss.insideQuantity">
              <auto-number-input
                v-model="form.insideQuantity"
                no="20"
                :precision="0"
                :min="0"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PiecesType2')" :class="variableCss.insidePacking">
              <!-- <cargo-advance-select
                :select-type="selectTypeNames.basic_data_Packing"
                filterable
                :default-value="form.insidePacking"
                style="width:100%;"
                @parentCallBack="p=>{form.insidePacking=p.value}"
              /> -->
              <cargo-packing-select
                no="21"
                :default-value="form.insidePacking"
                @change="p => {form.insidePacking=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Weight')" :class="variableCss.weight">
              <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
                <el-input-number
                  v-model="form.weight"
                  no="22"
                  :precision="3"
                  :min="0"
                  :controls="false"
                  :disabled="!isJydEditJobFields"
                  style="flex: 1"
                  @change="p=>{pm.calculateChargeWeight();}"
                />
                <span>KGS</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Cubage')" :class="variableCss.cubage">
              <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
                <el-input-number
                  v-model="form.cubage"
                  no="23"
                  :precision="3"
                  :min="0"
                  :controls="false"
                  :disabled="!isJydEditJobFields"
                  style="flex: 1"
                  @change="p=>{pm.calculateChargeWeight();}"
                />
                <span>CBM</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ChargedWeightRT')">
              <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
                <el-input-number
                  v-model="form.chargeWeight"
                  no="24"
                  :precision="3"
                  :min="0"
                  :controls="false"
                  style="flex: 1"
                />
                <span>M/T</span>
              </div>
            </el-form-item>
            <el-form-item :class="'auto-width '+variableCss.cargoEnglishName">
              <div style="display: flex;justify-content: flex-end">
                <el-button v-if="job.typeMBL===BillType.MERGE_BILL_TYPE.code" no="25" type="primary" @click="pm.getCargoEnglishNameFromMergeJob()">{{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromMergeJob') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item
              class="auto-width"
              :label="$t('SeaExport.EnglishDescriptionOfGoods')"
              :class="variableCss.cargoEnglishName"
            >
              <special-character-tip :texts="specialCharCheck.cargoEnglishName">
                <cargo-rich-textarea
                  ref="cargoTextarea1"
                  v-model="form.cargoEnglishName"
                  no="26"
                  :warning-count="seMarkWarningColor"
                  :text-chars="seMarkMaxChars"
                  wrap-symbol="r"
                  :disabled="!isEdit"
                  :auto-uppercase="isUppercaseByConfig"
                  auto-half-word
                  style="height: 110px"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,val=>{form.cargoEnglishName=val},isUppercaseByConfig, {
                    warningCount: seMarkWarningColor,
                    maxChar: seMarkMaxChars,autoHalfWord: true,autoUppercase:isUppercaseByConfig
                  })"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item :class="'auto-width '+variableCss.mark">
              <div style="display: flex;justify-content: flex-end">
                <el-button v-if="job.typeMBL===BillType.MERGE_BILL_TYPE.code" no="27" type="primary" @click="pm.getMarkFromMergeJob()">{{ $t('SeaExport.CopyMarkFromMergeJob') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Marks')" :class="'auto-width '+variableCss.mark">
              <special-character-tip :texts="specialCharCheck.mark">
                <cargo-rich-textarea
                  ref="cargoTextarea2"
                  v-model="form.mark"
                  no="28"
                  :warning-count="seMarkWarningColor"
                  :text-chars="seMarkMaxChars"
                  :disabled="!isEdit"
                  wrap-symbol="r"
                  :auto-uppercase="isUppercaseByConfig"
                  auto-half-word
                  style="height: 110px"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{form.mark=val},isUppercaseByConfig , {
                    warningCount: seMarkWarningColor,
                    maxChar: seMarkMaxChars,autoHalfWord: true,autoUppercase:isUppercaseByConfig
                  })"
                />
              </special-character-tip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CapitalizedNumbersOfPackages')" class="auto-width">
              <el-input v-model="form.quantitySum" :disabled="true" no="56" />
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <span>{{ $t('SeaExport.HsCode') }}</span>
              </div>
              <special-character-tip :texts="specialCharCheck.hsCode">
                <el-input
                  v-model="form.hsCode"
                  no="hsCode"
                  type="textarea"
                  :rows="5"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),form.hsCode,val=>{form.hsCode=val})"
                />
              </special-character-tip>
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="100px" label-position="right" style="height:100%">
            <span class="title">{{ $t('SeaExport.TransportInfo') }}</span>
            <el-form-item label="MB/L NO2.">
              <el-input v-model="form.mblNbr2" no="29" />
            </el-form-item>
            <el-form-item label="HB/L NO2.">
              <el-input :disabled="true" :value="form.hblNbr2" no="52" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.VesselAndVoyage')">
              <el-input :disabled="true" :value="txtFirstVesselVoyage" no="53" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfDeparture')">
              <el-input :disabled="true" :value="sailingDate" no="54" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfReceiptOnBl')" :class="variableCss.dispatchingPlace">
              <cargo-advance-select
                :disabled="true"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.dispatchingPlaceCode||''"
                tag-name="englishName"
                no="55"
                @parentCallBack="p=>{pm.portChange(p, 'dispatchingPlace')}"
              />
              <special-character-tip :texts="specialCharCheck.dispatchingPlace">
                <el-input v-model="form.dispatchingPlace" no="30" />
              </special-character-tip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfLoadingOnBl')" :class="variableCss.loadingPort">
              <cargo-advance-select
                :disabled="true"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.loadingPortCode||''"
                tag-name="englishName"
                no="loadingPortCode"
                @parentCallBack="p=>{pm.portChange(p, 'loadingPort')}"
              />
              <special-character-tip :texts="specialCharCheck.loadingPort">
                <el-input v-model="form.loadingPort" no="31" />
              </special-character-tip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfDischargeOnBl')" :class="variableCss.dischargingPort">
              <cargo-advance-select
                :disabled="true"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.dischargingPortCode||''"
                tag-name="englishName"
                no="dischargingPortCode"
                @parentCallBack="p=>{pm.portChange(p, 'dischargingPort')}"
              />
              <special-character-tip :texts="specialCharCheck.dischargingPort">
                <el-input v-model="form.dischargingPort" no="32" />
              </special-character-tip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfDeliveryOnBl')" :class="variableCss.destinationPort">
              <cargo-advance-select
                :disabled="true"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="form.destinationPortCode||''"
                tag-name="englishName"
                no="destinationPortCode"
                @parentCallBack="p=>{pm.portChange(p, 'destinationPort')}"
              />
              <special-character-tip :texts="specialCharCheck.destinationPort">
                <el-input v-model="form.destinationPort" no="33" />
              </special-character-tip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BlFinalDestination')">
              <el-input v-model="form.destinationPlace" no="34" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MethodOfMblPayment')">
              <el-input
                no="35"
                :value="ColumnUtils.paymentTermLabelFunc(form.paymentTerm)"
                @input="val=>{form.paymentTerm=val}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfMblPayment2')">
              <el-input :disabled="true" :value="form.paymentPlaceBL" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TransportationClause')">
              <el-input :disabled="true" :value="job.freightTerm" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.NoOfOriginalBls')" :class="variableCss.BLNumber">
              <el-input v-model="form.blNumber" no="36" :class="variableCss.BLNumber" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfIssue')">
              <el-input v-model="form.signPlaceBL" no="37" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfIssue')">
              <el-date-picker v-model="form.signDateBL" no="38" style="width: 100%" type="date" value-format="yyyy-MM-dd" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BlRemarks')" :class="variableCss.remarks">
              <special-character-tip :texts="specialCharCheck.remarks">
                <cargo-rich-textarea
                  v-model="form.remarks"
                  no="39"
                  :disabled="readonly"
                  :text-chars="0"
                  wrap-symbol="r"
                  style="height: 110px;"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.BlRemarks'),form.remarks,val=>{form.remarks=val},true, {
                    warningCount: 45,
                    maxChar: 0
                  })"
                />
              </special-character-tip>
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="108px" label-position="right" style="height:100%">
            <span class="title">{{ $t('SeaExport.OtherInfo') }}</span>
            <el-form-item
              v-show="job.typeMBL===BillType.SPLIT_BILL_TYPE.code"
              label-width="0"
              class="auto-width"
            >
              <cargo-ag-grid
                no="40"
                :grid-options="splitOrder.gridOptions"
                :column-defs="splitOrder.columnDefs"
                :row-data="splitOrderFinalRowData"
                style="width:100%;height:200px"
                @gridReady="splitOrderReady"
              />
              <div style="padding:5px 0">
                <div style="float:right">
                  <el-button no="41" type="primary" @click="pm.onAddSplitDocEvent()">{{ $t('SeaExport.Add') }}</el-button>
                  <el-button no="42" type="danger" @click="pm.onRemoveSliptDocEvent()">{{ $t('SeaExport.Delete') }}</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item
              v-show="job.typeMBL===BillType.MERGE_BILL_TYPE.code"
              label-width="0"
              class="auto-width"
            >
              <cargo-ag-grid
                no="43"
                config-module="150005"
                :grid-options="mergeOrder.gridOptions"
                :column-defs="mergeOrder.columnDefs"
                :row-data="mergeOrderFinalRowData"
                style="width:100%;height:200px"
                @gridReady="params=>{mergeOrder.gridApi=params.api}"
              />
              <div style="padding:5px 0">
                <div style="float:right">
                  <el-button no="44" type="primary" @click="pm.onJobsAdd()">{{ $t('SeaExport.Add3') }}</el-button>
                  <el-button no="45" type="danger" @click="pm.onJobsRemove()">{{ $t('SeaExport.Delete') }}</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BlType')">
              <el-select
                no="46"
                :value="form.releaseType||''"
                @input="val=>{form.releaseType=val}"
                @change="val=>{pm.cmbreleaseTypeMBLChangeHandler(val)}"
              >
                <el-option
                  v-for="(item,index) in blModeList"
                  :key="index"
                  :label="item.name"
                  :value="item.serialNumber"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BillingOfLadingRecordManager')">
              <a
                class="el-button el-button--primary el-button--mini"
                :class="isEdit?'is-disabled':''"
                style="display:inline-block;width: 100%;text-align: center;"
                no="70"
                @click="isEdit?'':statusChangeHistoryDialog.visible=true"
              >……</a>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CheckingStatus')" class="red ">
              <el-input :value="lblCfrState" :disabled="true" no="57" />
            </el-form-item>

            <!-- 提单签发状 -->
            <el-form-item :label="$t('SeaExport.BillLadingIssued')" class="red">
              <el-input v-model="billLadingIssued" :disabled="true" no="58" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ReleasingStatus')" class="red">
              <el-input :disabled="true" :value="lblReleaseState" style="margin-bottom: 5px" no="59" />
              <a
                v-permission="['button_SingleRelease_singleRelease']"
                class="el-button el-button--primary el-button--mini"
                :class="btnReleasingDisabled?'is-disabled':''"
                style="float: right;margin-left:5px"
                no="60"
                @click="btnReleasingDisabled?'':pm.btnReleasingClickHandler()"
              >{{ form.cfmState === 10 ? $t('SeaExport.CancelReleasing') : $t('SeaExport.Releasing') }}</a>
              <a
                v-permission="['button_SingleRelease_getBack']"
                class="el-button el-button--primary el-button--mini"
                :class="btnGetBackDisabled?'is-disabled':''"
                style="float: right"
                no="61"
                @click="btnGetBackDisabled?'':pm.btnGetBackClickHandler()"
              >{{ form.bliStatus === 7 ? $t('SeaExport.CancelGetBack') : $t('SeaExport.Back') }}</a>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.RequestReleaseState')" class="red">
              <el-input :value="form.requestReleaseState === 0 ? $t('SeaExport.NotApplying') : $t('SeaExport.Requested')" :disabled="true" />
              <cargo-button-container
                no="requestReleaseState"
                :disabled="btnReleasingDisabled"
                style="float:right;margin-left:5px"
                @click="pm.btnRequestReleasingClickHandler()"
              >
                <el-button v-permission="['button_M/HBL_SingleReleaseMBL']" type="primary">{{
                  form.requestReleaseState === 0 ? $t('SeaExport.ApplyForARelease') : $t('SeaExport.WithdrawTheRequestForRelease')
                }}
                </el-button>
              </cargo-button-container>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ReleaseEligibleStatus')" class="red">
              <el-input :value="releaseEligibleLabel" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.preverifyDate')">
              <el-date-picker
                v-model="form.reviewDate"
                :disabled="true"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                no="62"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ReleasingDate')">
              <el-date-picker
                v-model="form.releaseDate"
                :disabled="true"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                no="63"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfCargoDetention')">
              <el-date-picker
                v-model="form.withholdDate"
                :disabled="true"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                no="64"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ShippingCompanySCAC')">
              <el-input :disabled="true" :value="txtCarrierScAc" no="65" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OverseasAgentSCAC')">
              <el-input :disabled="true" :value="txtBookingAgentScAc" no="66" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContainerAmount')">
              <cargo-rich-textarea
                v-model="form.seaeq"
                no="47"
                :disabled="readonly"
                :text-chars="0"
                wrap-symbol="r"
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.ContainerAmount'),form.seaeq,val=>{form.seaeq=val},true, {
                  warningCount: 45,
                  maxChar: 0
                })"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CNTRNOSSEALNOS')">
              <cargo-rich-textarea
                v-model="form.container"
                no="48"
                :disabled="readonly"
                :text-chars="0"
                wrap-symbol="r"
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.CNTRNOSSEALNOS'),form.container,val=>{form.container=val},true, {
                  warningCount: 45,
                  maxChar: 0
                })"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ReasonOfCargoDetention')">
              <el-input :disabled="true" :value="form.withholdReason" type="textarea" :rows="5" no="67" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PortRequirement')">
              <el-input v-model="form.portRequirement" :disabled="readonly" no="portRequirement" type="textarea" :rows="5" />
              <div style="display: flex;line-height: 16px;margin-top: 5px;cursor: pointer;" @click="downloadAttachment(form.regionWarehouseMappingUuid)">
                <i class="el-icon-paperclip" style="font-size: 16px;" />
                <div style="font-size: 12px;text-decoration: underline;color: blue;">{{ $t('SystemMaintenance.PortRequirementsRelatedDocuments') }}</div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div v-if="showEdiContainer && form.docType" class="section">
        <!--      <div v-if="showEdiContainer && form.docType" class="section" :style="{'min-width':job.typeMBL===BillType.MERGE_BILL_TYPE.code?'1599px':'1562px'}">-->
        <span class="title">{{ $t('SeaExport.BillOfLadingPackingInfo') }}</span>
        <div style="display:flex;flex-direction:column">
          <div v-show="isEdit" style="padding:5px 0">
            <el-button no="49" type="primary" @click="cargoDocUsageSelectedDialog.visible=true">{{ $t('SeaExport.AddPackingInfo') }}</el-button>
            <el-button no="50" type="primary" @click="removeContainerUsageClickHandler">{{ $t('SeaExport.RemovePackingInfo') }}</el-button>
          </div>
          <cargo-ag-grid
            no="51"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="ediContainerFinalRowData"
            style="width:100%;height:350px"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :disabled="readonly"
        style="height: 320px;"
        no="advanceTextDialogTextarea"
      />
      <span slot="footer">
        <el-button v-show="isEdit" type="primary" no="68" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="69"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog :visible.sync="billAddressDialog.visible" :params="form" :job="job" @callback="codeSearchCallback" />
    <!-- 工作单检索弹窗 -->
    <job-no-transcribe-dialog
      :visible.sync="searchBillNoDialog.visible"
      :params="searchBillNoDialog.params"
      @selected="searchBillNoDialog.selectHandler"
    />
    <!-- 提单日志弹窗 -->
    <status-change-history-dialog
      :visible.sync="statusChangeHistoryDialog.visible"
      :business-data-id="form.uuid"
    />
    <!-- 选择装箱信息弹窗 -->
    <add-cargo-doc-container-dialog
      :visible.sync="cargoDocUsageSelectedDialog.visible"
      :job="job"
      :doc-type="CargoDocConsts.MBL2"
      :uuid-not-empty="true"
      :cargo-docs="job.typeMBL === BillType.SPLIT_BILL_TYPE.code ? splitOrderFinalRowData : null"
      @callback="cargoDocUsageSelectedDialog.callback"
    />
    <!-- 邀请对单弹窗 -->
    <email-input
      v-if="emailInput.visible"
      :visible.sync="emailInput.visible"
      :context="context"
      :job="job"
      source="tabMBL2"
      :is-copy-link="true"
      :job-eamil-data="jobEamilData"
      :send-email-data="emailInput"
      :send-call-back="onEmailExecute"
    />
    <!-- 对单历史弹窗 -->
    <match-history-dialog
      :visible.sync="matchHistoryDialog.visible"
      :cargo-doc-uuid="form.uuid"
    />
    <!--取装箱信息件毛体-->
    <sync-container-info-dialog
      ref="syncContainerInfoDialog"
      :visible.sync="syncContainerInfoDialog.visible"
      :change-post-func="syncContainerInfoChangeHandle"
    />
  </div>
</template>

<script>
import { TabMBL2PM } from './tabMBL2PM'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import statusChangeHistoryDialog from '@/components/Cargo/Job/statusChangeHistoryDialog'
import AddCargoDocContainerDialog from '@/views/cargo/v0/SeaExport/components/booking/AddCargoDocContainerDialog'
import moment from 'moment'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import jobNoTranscribeDialog from '@/components/Cargo/Job/jobNoTranscribeDialog'
import { formatNumberToThousands } from '@/utils'
import ColumnUtils from '@/utils/ColumnUtils'
import { ensureExecuteSuccess } from '@/utils/commonUtil'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import { BillAddressCommonPM } from '@/class/common/BillAddressCommonPM'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import matchHistoryDialog from '@/components/Cargo/Job/matchHistoryDialog'
import emailInput from '@/components/Cargo/Job/emailInput'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { sendHblCargoDocEmail } from '@/api/sendEmailService'
import CargoButtonContainer from '@/components/Cargo/Common/cargoButtonContainer'
import * as CargoDocCfmState from '@/class/cargo/model/parameters/CargoDocCfmState'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { CheckCargoDocHistory } from '@/class/model/booking/CheckCargoDocHistory'
import { cache } from '@/utils/cacheManager'
import specialCharacterTip from '@/components/Cargo/Common/specialCharacterTip.vue'
import SyncContainerInfoDialog from '@/components/Cargo/Job/syncContainerInfoDialog.vue'
import { INTELLIGENT_DOCUMENT_SOURCE_5 } from '@/class/cargo/model/parameters/SystemConstants'
import { getReleaseEligibleLabel } from '@/utils/releaseEligibility'
export default {
  name: 'TabMbl2',
  components: {
    specialCharacterTip,
    SyncContainerInfoDialog,
    CargoButtonContainer, CargoRichTextarea, cargoPackingSelect, cargoAdvanceSelect, cargoInput, billAddressDialog,
    jobNoTranscribeDialog, statusChangeHistoryDialog, AddCargoDocContainerDialog, AutoNumberInput, matchHistoryDialog, emailInput },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      jobMblBliStatus: 0,
      billLadingIssued: '',
      jobEamilData: {},
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      pm: new TabMBL2PM(this),
      moment,
      BillType,
      CargoDocConsts,
      CargoDocUtil,
      synchronousShipperCodeAndConsigneeCodeAndNotifyCode: false,
      mblMergeUpdateMainNumber: false,
      syncSignDateBl: false,
      selectTypeNames: TYPE_NAMES,
      maxChars: 45,
      warningCount: -1,
      seMarkMaxChars: 45,
      seMarkWarningColor: -1,
      isUppercase: true,
      blModeList: [
        { serialNumber: 1, code: 'ORIGINAL', name: 'ORIGINAL', localName: this.$t('SeaExport.OriginalNormal') },
        { serialNumber: 2, code: 'SURRENDERED', name: 'SURRENDERED', localName: this.$t('SeaExport.TelexRelease') },
        { serialNumber: 3, code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: this.$t('SeaExport.TelexRelease') }
      ],
      job: {},
      form: new SeaCargoDoc().fillDefaultValue().getData(),
      addrPM: new BillAddressCommonPM(this),
      lblReleaseState: '',
      txtCarrierScAc: '',
      txtBookingAgentScAc: '',
      command1: this.$t('SeaExport.CodeSearching'),
      alsoNotify: {
        line1: '',
        line2: '',
        line3: ''
      },
      variableCss: {
        quantity: '',
        shipperCode: '', // 发货人1
        shipperLine: '', // 发货人1
        shipperLine1: '', // 发货人1
        shipperLine2: '', // 发货人2
        shipperLine3: '', // 发货人3
        shipperLine4: '', // 发货人4
        shipperLine5: '', // 发货人5
        shipperLine6: '', // 发货人6
        consigneeCode: '',
        consigneeLine: '', // 收货人1
        consigneeLine1: '', // 收货人1
        consigneeLine2: '', // 收货人2
        consigneeLine3: '', // 收货人3
        consigneeLine4: '', // 收货人4
        consigneeLine5: '', // 收货人5
        consigneeLine6: '', // 收货人6
        consigneeLine7: '', // 收货人7
        notifyCode: '',
        notifyLine: '', // 通知人1
        notifyLine1: '', // 通知人1
        notifyLine2: '', // 通知人2
        notifyLine3: '', // 通知人3
        notifyLine4: '', // 通知人4
        notifyLine5: '', // 通知人5
        notifyLine6: '', // 通知人6
        BLNumber: '', // 提单份数
        packing: '', // 包装
        insideQuantity: '', // 小件数
        insidePacking: '', // 小件数包装类型
        dispatchingPlace: '', // (提单发货地)发货地
        weight: '', // 提单毛重
        cubage: '', // 提单体积
        loadingPort: '', // (提单起运港)装货港
        dischargingPort: '', // (提单卸货港)中转港
        destinationPort: '', // (提单交货地)目的港
        cargoEnglishName: '', // 英文品名
        mark: '', // 唛头
        remarks: ''// 备注
      },
      // 拆单
      splitOrder: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          context: {
            componentParent: this
          },
          onRowClicked: event => { this.curMbl = event.data; this.pm.onSelectionChange(event.data) }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.HblNo2'),
            field: 'hblNbr2',
            width: 130
          },
          {
            headerName: this.$t('SeaExport.MblNo'),
            field: 'mblNbr2',
            width: 130,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'span'
            }
          }
        ],
        rowData: [],
        gridApi: null
      },
      // 并单
      mergeOrder: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.BusinessNo'),
            colId: 'jobNo',
            field: 'jobNo',
            width: 109
          },
          {
            headerName: this.$t('SeaExport.Mbl2'),
            colId: 'mbl',
            field: 'mbl',
            width: 109,
            hide: true
          },
          {
            headerName: this.$t('SeaExport.Quantity'),
            colId: 'quantityActual',
            field: 'quantityActual',
            width: 85
          },
          {
            headerName: this.$t('SeaExport.Weight'),
            colId: 'weightActual',
            field: 'weightActual',
            width: 85
          },
          {
            headerName: this.$t('SeaExport.Cubage'),
            colId: 'cubageActual',
            field: 'cubageActual',
            width: 85
          },
          {
            headerName: this.$t('SeaExport.SONO'),
            colId: 'soNo',
            field: 'soNo',
            width: 85
          }
        ],
        rowData: [],
        gridApi: null
      },
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        rowHeight: 32,
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        },
        context: {
          componentParent: this
        }
      },
      rowData: [],
      gridApi: null,
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: 45,
          maxChar: 45, autoUppercase: false, autoHalfWord: false
        }
      },
      billAddressDialog: {
        visible: false
      },
      searchBillNoDialog: {
        visible: false,
        params: {},
        selectHandler: () => { }
      },
      statusChangeHistoryDialog: {
        visible: false
      },
      cargoDocUsageSelectedDialog: {
        visible: false,
        callback: rows => { this.pm.usageSelectCallBackFunc(rows) }
      },
      addJoinMergeJobList: [], // 当前添加的并单（未保存）
      showEdiContainer: false, // 是否展示提单装箱信息
      curMbl: null,
      matchHistoryDialog: {
        visible: false
      },
      specialCharCheck: {
        cargoEnglishName: null,
        mark: null,
        shipperLine1: null,
        shipperLine2: null,
        shipperLine3: null,
        shipperLine4: null,
        shipperLine5: null,
        shipperLine6: null,
        consigneeLine1: null,
        consigneeLine2: null,
        consigneeLine3: null,
        consigneeLine4: null,
        consigneeLine5: null,
        consigneeLine6: null,
        notifyLine1: null,
        notifyLine2: null,
        notifyLine3: null,
        notifyLine4: null,
        notifyLine5: null,
        notifyLine6: null,
        hsCode: null,
        remarks: null,
        dispatchingPlace: null,
        loadingPort: null,
        dischargingPort: null,
        destinationPort: null
      },
      syncContainerInfoDialog: {
        visible: false
      },
      lblCfrState: '',
      command2: this.$t('SeaExport.InviteToChecktheBL'),
      emailInput: {
        anonSessionId: '',
        visible: false,
        emailTitle: '',
        emailContent: '',
        fileIdList: ''
      },
      isItCleared: false,
      isXy: false,
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && (!this.form.uuid || this.form.state < 2)
    },
    txtFirstVesselVoyage() {
      const job = this.job
      return (job.vessel ? job.vessel : '') + (job.vessel && job.voyageFlight ? ' ' : '') + (job.voyageFlight ? job.voyageFlight : '')
    },
    btnGetBackDisabled() {
      // this.form.bliStatus === 7 ===> 按钮为撤销取回   mblBliStatus不为已取回，按钮就置灰
      // this.form.bliStatus !== 7 ===> 按钮为取回      mblBliStatus=已取回/已接收/已认领 时禁止 操作取回按钮
      return this.isEdit || !this.form.uuid ||
        (this.form.bliStatus === 7 && (this.jobMblBliStatus !== CargoDocCfmState.CARGODOC_CFM_STATE_GET_BACKED.code)) ||
        (this.form.bliStatus !== 7 && (this.jobMblBliStatus === CargoDocCfmState.CARGODOC_CFM_STATE_GET_BACKED.code ||
          this.jobMblBliStatus === CargoDocCfmState.CARGODOC_CFM_STATE_RECEIVED.code ||
          this.jobMblBliStatus === CargoDocCfmState.CARGODOC_CFM_STATE_CLAIMED.code))
    },
    btnReleasingDisabled() {
      return this.isEdit || !this.form.uuid
    },
    config() {
      return this.context.config
    },
    // 开航日期
    sailingDate() {
      const val = this.syncSignDateBl ? this.job.atd : this.job.etd
      if (val === null || val === '') {
        return ''
      }
      return moment(val).format('YYYY-MM-DD')
    },
    splitOrderFinalRowData() {
      return this.splitOrder.rowData.filter(p => !p.deleted && p.docType === CargoDocConsts.MBL2).sort((a, b) => {
        const suffixA = a.hblNbr2.replace(`${this.job.jobNo}-`, '')
        const suffixB = b.hblNbr2.replace(`${this.job.jobNo}-`, '')
        return suffixA - suffixB
      })
    },
    mergeOrderFinalRowData() {
      return this.mergeOrder.rowData.filter(p => !p.deleted)
    },
    ediContainerFinalRowData() {
      return this.rowData.filter(p => !p.deleted)
    },
    releaseEligibleLabel() {
      return getReleaseEligibleLabel(this.job && this.job.seaCargoDoc, this.$t, this)
    },
    columnDefs() {
      return [
        {
          headerName: '',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('SeaExport.ContainerSize'),
          field: 'eqSize',
          width: 160
        }, {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'eqType',
          width: 160
        }, {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNo',
          width: 160
        }, {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNo',
          width: 160
        }, {
          headerName: this.$t('SeaExport.Quantity'),
          colId: 'quantity',
          field: 'quantity',
          width: 160,
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 0, true)),
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 0
            }
          },
          onCellValueChanged: p => this.packageInfoChanged(p)
        },
        {
          headerName: this.$t('SeaExport.Weight'),
          colId: 'weight',
          field: 'weight',
          width: 160,
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3
            }
          },
          onCellValueChanged: p => this.packageInfoChanged(p)
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          colId: 'cubage',
          field: 'cubage',
          width: 160,
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3
            }
          },
          onCellValueChanged: p => this.packageInfoChanged(p)
        },
        {
          headerName: 'part of',
          colId: 'partOf',
          field: 'partOf',
          suppressColumnsToolPanel: this.job.typeMBL !== BillType.SPLIT_BILL_TYPE.code,
          hide: this.job.typeMBL !== BillType.SPLIT_BILL_TYPE.code,
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'el-checkbox',
            valueChanged: p => {
              this.onPartOfChange(p)
            }
          }
        }
      ]
    },
    btnBLConfirmDisabled() {
      return this.isEdit || !this.form.uuid
    },
    user() {
      return this.context.user
    },
    isJyd() { // 是否集翊达
      return this.config && String(this.config.get('ToExoSystem')) === 'JYD'
    },
    isJydEditJobFields() { // 有客服权限，没有操作权限，则不能编辑业务的某些字段【新增业务除外】
      return JobUtils.editJobFields(this.isJyd && this.job.uuid)
    }
  },
  watch: {
    'form.bliStatus': {
      handler(val) {
        if (val || val === 0) {
          this.jobMblBliStatus = val
        }
      }
    }
  },
  created() {
    this.context.loading = true
    // await this.context.prepareData()
    this.notUppercaseShipperConsigneNotify = Number(this.config.get('NotUppercaseShipperConsigneNotify')) !== 1
    this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    this.isXy = String(this.config.get('ToExoSystem')) === 'XYCW'
    this.pm.init()
    this.visible = true
    this.context.loading = false
  },
  methods: {
    updateCfm() {
      this.job.mblCfmState = 11
      this.form.cfmState = 11
      this.lblCfrState = ColumnUtils.cfmStatusLabelFunc(this.job.mblCfmState)
    },
    splitOrderReady(params) {
      this.splitOrder.gridApi = params.api
    },
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        this.pm.showScac()
        if (this.showEdiContainer) {
          this.gridApi.refreshCells({ force: true })
        }
        return
      }
      this.syncSignDateBl = Number(this.config.get('syncSignDateBl')) === 1
      this.job = row
      this.addJoinMergeJobList = []
      this.showEdiContainer = false
      await this.pm.changeJob()
      await this.pm.display()
      await this.pm.fillView()
      await this.pm.checkSpecialCharacter()
      this.$nextTick(async() => {
        await ensureExecuteSuccess(() => this.splitOrder.gridApi)
        let selectedNode = null
        const { rowsToDisplay } = this.splitOrder.gridApi.getModel()
        if (this.curMbl) {
          selectedNode = rowsToDisplay.find(node => node.data.hblNbr2 === this.curMbl.hblNbr2) || rowsToDisplay[0]
        } else {
          selectedNode = rowsToDisplay[0]
        }
        const selectedData = selectedNode ? selectedNode.data : this.splitOrderFinalRowData[0]
        if (selectedData) {
          selectedNode.setSelected(true)
          await this.pm.onSelectionChange(selectedData)
        }
      })
      this.lblCfrState = ColumnUtils.cfmStatusLabelFunc(this.form.cfmState)
      this.billLadingIssued = ColumnUtils.bliStatusLabelFunc(this.form.bliStatus)
      this.lblReleaseState = ColumnUtils.releaseStateLabelFunc(this.form.releaseState)
      // 同步值 因为seaCargoDoc 所以要根据取docType = MBL的值
      this.job.seaCargoDoc.forEach(val => {
        if (val.docType === 'MBL2' && this.form.hblNbr2 === val.hblNbr2) {
          this.jobMblBliStatus = val.bliStatus
        }
      })
    },
    getSubmitData() {
      // CARGO-20365先触发富文本组件失焦事件去除尾部换行符
      this.$refs.cargoTextarea1.hanldeFormat()
      this.$refs.cargoTextarea2.hanldeFormat()
      this.validateRequire(this.job.typeMBL === BillType.SPLIT_BILL_TYPE.code ? this.splitOrder.rowData : [this.form])
      if (this.job.typeMBL === BillType.SPLIT_BILL_TYPE.code) {
        CargoDocUtil.checkDocQWCSame(this.splitOrderFinalRowData, this.job.containerUsages)
      }
      this.pm.validateForm()
      this.pm.fillModel()
      let seaCargoDoc = null
      if (this.job.typeMBL === BillType.SPLIT_BILL_TYPE.code) {
        seaCargoDoc = this.splitOrder.rowData
      } else {
        seaCargoDoc = [this.form]
      }
      console.log('seaCargoDoc=========', seaCargoDoc)
      return {
        seaCargoDoc,
        isItCleared: this.isItCleared,
        mblJoinMergeJobList: this.addJoinMergeJobList,
        job: { ...this.job }
      }
    },
    validateRequire(cargoDocList) {
      // UI自定义中用到
    },
    executeTask() {
      this.pm.executeTask()
    },
    commandHandle(command) {
      switch (command) {
        case this.$t('SeaExport.CodeSearching'):
          this.billAddressDialog.visible = true
          break
        case this.$t('SeaExport.CopyFromTheLastTime'):
          this.pm.onCopy1()
          break
        case this.$t('SeaExport.CopyFromOtherBill'):
          Object.assign(this.searchBillNoDialog.params, {
            docType: 'MBL',
            selectType: 'single',
            job: this.job,
            jobNo: this.job.jobNo
          })
          this.searchBillNoDialog.selectHandler = p => { this.pm.selectionItemHandler(p) }
          this.searchBillNoDialog.visible = true
          break
        case this.$t('SeaExport.InviteToChecktheBL'):
          JobUtils.checkBillTip(this.form, this.doInviteConfirmData)
          break
        case this.$t('SeaExport.IdentificationList'):
          this.$router.push({
            name: 'OcrRecognition',
            query: {
              uuid: this.job.uuid,
              docUuid: this.form.uuid,
              source: INTELLIGENT_DOCUMENT_SOURCE_5.code
            }
          })
          break
        case this.$t('SeaExport.CheckingHistory'):
          this.matchHistoryDialog.visible = true
          break
      }
    },
    doInviteConfirmData() {
      SeaCargoDoc.getCfmAddress(this.form.uuid, this.form.version, this.user.tenantName, this.job.jobNo, this.$store.getters.currentOfficeId, this.user.email).then(data => {
        if (data.cargoDoc) {
          Object.assign(this.form, data.cargoDoc)
          this.pm.showDocState()
        }
        this.emailInput.emailTitle = ''
        if (this.form.hblNbr2) {
          this.emailInput.emailTitle = `${this.$t('SeaExport.ConfirmationBillOfLading')}-${this.form.hblNbr2}(${this.context.office.chineseName})`
        } else {
          this.emailInput.emailTitle = `${this.$t('SeaExport.ConfirmationBillOfLading')}(${this.context.office.chineseName})`
        }
        this.emailInput.anonSessionId = data.anonSessionId
        this.emailInput.emailContent = data.url
        this.emailInput.fileIdList = ''
        this.emailInput.visible = true
        this.jobEamilData = {
          anonSessionId: this.emailInput.anonSessionId,
          jobuuid: this.job.uuid,
          cargoDocUuid: this.form.uuid,
          format: PrintTemplateManager.FORMAT_PDF,
          createdBy: this.$store.getters.userId,
          templateType: this.form.docType,
          className: 'CargoDoc',
          classNameType: SystemConstants.BOOKING,
          officeId: this.$store.getters.currentOfficeId,
          tenantName: this.user.tenantName
        }
      })
    },
    codeSearchCallback(data) {
      if (data.shipperCode) {
        this.form.shipperCode = data.shipperCode
      }
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
      }
      if (data.consigneeCode) {
        this.form.consigneeCode = data.consigneeCode
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
      }
      if (data.notifyCode) {
        this.form.notifyCode = data.notifyCode
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
      }
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['shipperLine' + i] || ''
        result += '\n'
      }
      result += (this.form['shipperLine7'] || '')
      return result.trimEnd()
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['consigneeLine' + i] || ''
        result += '\n'
      }
      result += (this.form['consigneeLine7'] || '')
      return result.trimEnd()
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['notifyLine' + i] || ''
        result += '\n'
      }
      result += (this.form['notifyLine7'] || '')
      return result.trimEnd()
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['notifyLine' + i] = ''
      }
    },
    showShipperDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.Shipper'), this.mergeShipperLine(), this.splitShipperLine, this.notUppercaseShipperConsigneNotify, {
        warningCount: this.warningCount,
        maxChar: this.maxChars, autoUppercase: this.notUppercaseShipperConsigneNotify, autoHalfWord: true
      })
    },
    showConsigneeDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.Consignee'), this.mergeConsigneeLine(), this.splitConsigneeLine, this.notUppercaseShipperConsigneNotify, {
        warningCount: this.warningCount,
        maxChar: this.maxChars, autoUppercase: this.notUppercaseShipperConsigneNotify, autoHalfWord: true
      })
    },
    showNotifyDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.NotifyParty'), this.mergeNotifyLine(), this.splitNotifyLine, this.notUppercaseShipperConsigneNotify, {
        warningCount: this.warningCount,
        maxChar: this.maxChars, autoUppercase: this.notUppercaseShipperConsigneNotify, autoHalfWord: true
      })
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObj = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
      const defaultFormatObj = {
        warningCount: 45,
        maxChar: 45, autoUppercase: false, autoHalfWord: false
      }
      this.advanceTextDialog.formatObj = formatObj ? { ...defaultFormatObj, ...formatObj } : defaultFormatObj
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    packageInfoChanged(params) {
      const newValue = Number(params.newValue)
      if (newValue < 0) {
        params.node.setDataValue(params.column.colId, 0)
        return
      }
      // 值未变更的情况下不用重新计算
      if (Number(params.newValue) === Number(params.oldValue)) return
      // 拆单专用
      const key = params.field || params.colDef.colId
      if (this.job.typeMBL === BillType.SPLIT_BILL_TYPE.code && !this.isXy) {
        let sum = 0
        for (const item of this.rowData) {
          sum += Number(item[key])
        }
        this.form[key] = sum
        CargoDocUtil.calculateSEChargeWeight(this.form)
      }
    },
    /**
     *  Part Of发生变更
     */
    onPartOfChange(params) {
      const partOf = params.data.partOf
      const containerUsageUuid = params.data.containerUsageUuid
      for (const row of this.splitOrderFinalRowData) {
        if (row.ediContainer) {
          for (const container of row.ediContainer) {
            if (container.containerUsageUuid === containerUsageUuid) {
              container.partOf = partOf
            }
          }
        }
      }
      this.gridApi.refreshCells({ force: true })
    },
    async removeContainerUsageClickHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('SeaExport.PleasePackingInformationToRemoved'))
        return
      }
      const delEdiUuids = []
      const rowData = []
      for (const item of this.rowData) {
        let isExist = false
        for (const row of rows) {
          if (row === item) {
            isExist = true
            delEdiUuids.push(row.uuid)
            break
          }
        }
        if (isExist) {
          item.deleted = true
        }
        if (!item.uuid && item.deleted) {
          continue
        }
        rowData.push(item)
      }
      this.rowData = rowData
      if (this.job.containers) {
        for (const container of this.job.containers) {
          if (container.containerUsage) {
            for (const usage of container.containerUsage) {
              if (usage.ediContainers) {
                for (const ediContainer of usage.ediContainers) {
                  if (delEdiUuids.indexOf(ediContainer.uuid) > -1) {
                    ediContainer.deleted = true
                  }
                }
              }
            }
          }
        }
      }
      await this.pm.refreshSeqContainer()
      // 拆单专用
      if (this.job.typeMBL === BillType.SPLIT_BILL_TYPE.code && !this.isXy) {
        this.pm.refreshEdiGrid()
      }
    },
    mergePaymentLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['paymentLine' + i] || ''
        result += '\n'
      }
      result += (this.form['paymentLine7'] || '')
      return result.trimEnd()
    },
    splitPaymentLine(val, extendData) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['paymentLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['paymentLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['paymentLine' + i] = ''
      }
      if (extendData) {
        this.form.paymentContact = extendData.contact
        this.form.paymentPhone = extendData.mobile
        this.form.paymentFax = extendData.fax
        this.form.paymentEmail = extendData.email
        this.form.paymentPostalCode = extendData.zipCode
        this.form.paymentCity = extendData.city
      }
    },
    showPaymentDialog() {
      this.showAdvanceTextDialog(this.$t('CargoMsg.Cargo_Payment1'), this.mergePaymentLine(), this.splitPaymentLine, true, {
        warningCount: this.warningCount,
        maxChar: this.maxChars, autoUppercase: true, autoHalfWord: true
      })
    },
    formatChange(detail) {
      this.form.showDetail = detail
      // 处理ALSO NOTIFY数据
      if (this.form.alsoNotify) {
        if (detail) {
          const alsoData = this.form.alsoNotify.split('\r')
          if (alsoData.length > 0) {
            this.alsoNotify.line1 = alsoData[0]
          }
          if (alsoData.length > 1) {
            this.alsoNotify.line2 = alsoData[1]
          }
          if (alsoData.length > 2) {
            this.alsoNotify.line3 = alsoData[2]
          }
        }
      }
    },
    summarizeAlso(val) {
      this.form.alsoNotify = val
      if (this.form.alsoNotify) {
        const alsoData = this.form.alsoNotify.split('\n')
        if (alsoData.length > 0) {
          this.alsoNotify.line1 = alsoData[0]
        }
        if (alsoData.length > 1) {
          this.alsoNotify.line2 = alsoData[1]
        }
        if (alsoData.length > 2) {
          this.alsoNotify.line3 = alsoData[2]
        }
      } else {
        this.alsoNotify.line1 = ''
        this.alsoNotify.line2 = ''
        this.alsoNotify.line3 = ''
      }
    },
    alsoChange() {
      this.form.alsoNotify = this.alsoNotify.line1 + '\r' + this.alsoNotify.line2 + '\r' + this.alsoNotify.line3
    },
    // 组装打印参数
    getPrintData() {
      if (!this.form || !this.form.uuid) {
        this.$message.warning(this.$t('Message.NoSelectedCargoDocInformation'))
        return
      }
      const params = {}
      params.cargoDocUuid = this.form.uuid
      params.DOC_UUID = this.form.uuid
      params.category = 'MBL2'
      params.ctx = new SeaExportJob(this.job)
      return params
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    },
    getClass(key, index) {
      const variableCss = this.variableCss[key + index]
      const shouldWarn = this.warningCount !== -1 && this.form[key + index].length > this.warningCount
      if (variableCss || shouldWarn) {
        return 'red'
      }
      return ''
    },
    endTabHandler() {
      // 切换页签调用的方法
      this.pm.validateForm()
    },
    /**
     * @private
     * 邀请对单邮件callBack
     * 返回方法
     */
    onEmailExecute(mailSubject, mailTo, mailCc, content, mailType, mailContent, pushLink) {
      const item = {}
      item.mailTo = mailTo
      item.pushLink = pushLink
      item.mailSubject = mailSubject
      item.mailCc = mailCc
      item.mailBcc = ''
      item.mailFrom = ''
      // item.mailFrom = this.getMailFrom() // 后端已经写死了，此方法无用
      item.cfmUrl = content
      item.anonSessionId = this.emailInput.anonSessionId
      item.jobuuid = this.job.uuid
      item.cargoDocUuid = this.form.uuid
      item.format = PrintTemplateManager.FORMAT_PDF
      item.createdBy = this.$store.getters.userId
      item.templateType = this.form.docType
      item.className = 'CargoDoc'
      item.classNameType = SystemConstants.BOOKING
      item.officeId = this.$store.getters.currentOfficeId
      item.tenantName = this.user.tenantName
      item.mailType = mailType || ''
      item.mailContent = mailContent || ''
      sendHblCargoDocEmail(item).then(res => {
        if (res.ok) {
          this.emailInput.visible = false
          this.$message.success(this.$t('CargoMsg.Cargo_EMSSCM'))
          this.pm.statusHistoryWaitConfirmSuccessHandler()
        } else {
          this.$message.warning(this.$t('SeaExport.MailSendingFailed'))
        }
      })
    },
    downloadAttachment(regionWarehouseMappingUuid) {
      JobUtils.downloadPortRequirementAttachment(regionWarehouseMappingUuid)
    },
    syncContainerInfoDialogHandle() {
      CargoDocUtil.syncContainerHandle(this, this.job, this.form, this.syncContainerInfoDialog)
    },
    syncContainerInfoChangeHandle() {
      // 调用各自原本的方法进行处理
      // 件
      this.pm.quantityChange()
      // 毛
      CargoDocUtil.changeBillOfLadingSynJob(this.job, this.form)
      // 体
      CargoDocUtil.changeBillOfLadingSynJob(this.job, this.form)
      // 计费重量
      CargoDocUtil.calculateSEChargeWeight(this.form)
    }
  }
}
</script>

<style lang="scss" scoped>
.form-column{
  .form-item-input{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    background-color: #fff;
    border: 1px solid #E4E7ED;
    span{
      width: 40px;
      height: 28px;
      line-height: 26px;
      box-sizing: border-box;
      padding-left: 5px;
      padding-top: 1px;
    }
    /deep/ input{
      border: 0;
      padding-right: 0 !important;
    }
  }
  .input-disabled{
    background-color: #f0f3f8 !important;
    cursor: not-allowed;
  }
}
</style>
